import dic from '@/assets/dictionary/index.js'
import { LANG } from '@/libs/constants'

const {
  clientsSection: { list },
} = dic[LANG]
export const newClients = (list) => {
  return [
    {
      id: 1,
      name: list[1].name,
      rank: list[1].rank,
      comment: list[1].comment,
      imgUrl: 'foto1.webp',
      imgClassicUrl: 'foto_ozuv-2.png',
    },
    {
      id: 2,
      name: list[2].name,
      rank: list[2].rank,
      comment: list[2].comment,
      imgUrl: 'foto2.webp',
      imgClassicUrl: 'foto_ozuv-1.png',
    },
    {
      id: 3,
      name: list[3].name,
      rank: list[3].rank,
      comment: list[3].comment,
      imgUrl: 'foto3.webp',
      imgClassicUrl: 'foto_ozuv.png',
    },
  ]
}

export default {
  namespaced: true,
  state: {
    clients: newClients(list),
  },
}
